import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
} from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../components/Button/Button';
import { Modal, ModalRef } from '../../../components/Modal/Modal';
import { useLanguage } from '../../../locale/useLanguage';
import { Routes } from '../../../routes/types';

type OrderHelpModalProps = {};

export const OrderHelpModal: React.ForwardRefExoticComponent<
  OrderHelpModalProps & React.RefAttributes<ModalRef>
> = forwardRef((_, forwardedRef) => {
  const [t] = useLanguage();
  const history = useHistory();
  const askSupportModalRef = useRef<ModalRef>(null);

  const closeModal = useCallback(() => {
    askSupportModalRef.current?.closeModal();
    history.push(Routes.Home);
  }, [history]);

  useImperativeHandle(forwardedRef, () => ({
    openModal: askSupportModalRef.current!.openModal,
    closeModal: askSupportModalRef.current!.closeModal,
  }));

  return (
    <>
      <Modal ref={askSupportModalRef}>
        <h3 className="modal-title">{t('orderHelpModal.title')}</h3>
        <p className="modal-description">{t('orderHelpModal.label')}</p>
        <div className="modal-button-container">
          <div className="refund-modal--cancel-button">
            <Button
              isPrimary
              onClick={closeModal}
              label={t('orderHelpModal.close')}
            />
          </div>
        </div>
      </Modal>
    </>
  );
});
